import { combineReducers } from '@reduxjs/toolkit';

import { builderReducer as builder } from '../../features/FormBuilder/data-store/builderSlice';
import { managementReducer as management } from '../../features/FormManagement/data-store/managementSlice';
import { initialDataReducer as initialData } from '../../features/FormPreview/data-store/initialDataSlice';
import { liveFormReducer as liveForm } from '../../features/LiveForm/data-store/liveFormSlice';

import { globalReducer as global } from './globalSlice';

const rootReducer = combineReducers({
  global,
  builder,
  management,
  liveForm,
  initialData,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
